export const YVN = { lat: 40.1872, lng: 44.5152 }
export const MAP_CONTAINER = 'map-container'
